<template>
<!--  eslint-disable-->
  <div id="PcHeader" :class="''"  v-cloak>
    <el-row class="userBar">
      <el-col :span="18" :offset="3">
        <el-col :span="4" :offset="0" class="logoPlatform">
          <img :src="logoUrl"/>
        </el-col>
        <el-col :span="12" :offset="0" class="navLink">
          <el-menu :default-active=activePageLinkIndex class="el-menu-demo" mode="horizontal"
                   id="pageLink">
            <template v-for="(item1, idx1) in pageLink">
              <el-submenu  v-if="item1.type == 'menu'" :index="item1.index" :key="item1.index">
                <template #title>
                  {{item1.name}}
                </template>
                <template v-for="(item2, idx2) in item1.children">
                  <el-submenu v-if="item2.type == 'menu'" :index="item2.index" :key="item2.index">
                    <template #title>
                      {{item2.name}}
                    </template>
                    <el-menu-item  v-for="(item3, idx3) in item2.children" :index="item3.index" :key="item3.index">
                      <router-link  :to="item3.url">
                        {{ item3.name }}
                      </router-link>
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item v-else :index="item2.index" :key="item2.index">
                    <router-link :to="item2.url">
                      {{ item2.name }}
                    </router-link>
                  </el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item  v-else :index="item1.index" :key="item1.index">
                <a v-if="idx1 == 1"  :href="item1.url">
                  {{ item1.name }}
                </a>
                <a v-else :href="item1.url" target="_blank">
                  {{ item1.name }}
                </a>
              </el-menu-item>
            </template>
          </el-menu>
        </el-col>
        <el-col :span="4" :offset="4" class="userLink" style="padding: 10px 0" v-if="!userInfo">
          <el-col :span="12" :offset="0">
            <router-link to="/pages/login/PcLogin" type="text" class="el-button">
              登录
            </router-link>
          </el-col>
          <el-col :span="12" :offset="0">
            <router-link to="/pages/login/UserRegister" type="text">
              注册
            </router-link>
          </el-col>
        </el-col>
        <el-col :span="4" :offset="4" class="userLink" v-if="userInfo">
          <el-col :span="16" :offset="0">
              <el-button style="float: right; margin-right: 10px;" @click="$router.push({path: userAfLink[0].url})" type="text"
                         title="个人中心">
                <span :title="userInfo.name">{{ userInfo.name.length <= 3 ? userInfo.name : (userInfo.name.slice(0, 3) + '...') }}</span>
              </el-button>
              <img @click="$router.push({path: userAfLink[0].url})" :src=userInfo.svg
                   style="width: 40px;height: 40px; float: right; cursor:pointer;"
                   fit="fill">
          </el-col>
          <el-col :span="8" :offset="0" >
            <el-button  @click="clearUser" type="text">
              注销
            </el-button>
          </el-col>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HeaderMixin from "@/components/Header/HeaderMixin";
export default {
  name: "PcHeader",
  mixins: [HeaderMixin],
  methods: {

  }
}
</script>

<style lang="less" scoped>
.el-menu--popup {
  a {
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;
    height: 100%;
  }
}
#PcHeader {
  background: transparent;
  width: 100%;
  height: 11vh;
  //font-size: 2rem!important;

  //.aggregateSearchInput {
  //  position: relative;
  //  left: -20px;
  //  width: 100%;
  //  &.el-input--suffix .el-input__inner {
  //    border-radius: 20px!important;
  //  }
  //}
  //
  //.aggregateSearchBtn {
  //  background-color: #409eff;
  //  color: white;
  //  left: 5px;
  //  position: relative;
  //  border-radius: 40px!important;
  //}

  a {
    text-decoration: none;
    color: inherit;
    color: #000000;
    display: block;
    min-width: 110px;
    min-height: 90px;
    font-family: Arial, Helvetica, "Microsoft Yahei", sans-serif;
    font-size: 18px!important;
    text-align: center;
    line-height: 90px;
    padding: 8px;
    //background-image: linear-gradient(-90deg, #81c9fe, #8bf);
  }
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom:none;
  }
  .el-submenu__title {
    padding: 0;
  }

  [v-cloak] {
    display: none;
  }
  .el-button{
    font-family: Arial, Helvetica, "Microsoft Yahei", sans-serif;
    font-size: 18px!important;
    color:#FFFFFF;
  }
  .logoPlatform {
    margin: 5px 0px 5px 12px;
    min-height: 80px;
    min-width: 280px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .logoPlatform img {
    max-height: 80px;
    max-width: 280px;
    //width: 100%;
    //height: 100%;
  }

  .el-menu-item, .el-submenu__title {
    height: 106px;
    line-height: 64px;
  }

  .input-with-select {
    margin: 10px 0px;
    /*width: 500px;*/
  }

  .input-with-select .el-input-group__append {
    font-size: 14px;
  }

  .tooltipClass {
    width: 350px;
    border: solid 1px #eeeeee;
  }

  /*用户导航栏*/

  .userBar {
    height: 106px;
    background: linear-gradient(-90deg, #81c9fe, #8bf);
    overflow: hidden;
  }
  .el-col-offset-4{
    margin-left:0px;
  }
  .navLink {
    li {
      @media screen and (min-width: 1519px) {
        margin-left: 20px;
      }
      @media screen and (max-width: 1519px) {
        margin-left: 10px;
      }
    }
  }

  .navLink ul, .navLink li {
    //padding: 0px 0px !important;
    //height: 64px !important;
    line-height: 64px !important;
    font-size: 18px!important;
  }

  .userLink {
    line-height: 18px;
  }

  .userLink a {
    color: #000000;
    text-decoration: none;
    font-size: 18px;
  }

  .userLink button {
    /*margin: 33px 0px 33px 3px !important;*/
  }

  .userLink button span {
    /*overflow: hidden;*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75px;
    display: block;
  }

  .userLink > div {
    margin: 23px 0px 33px 0px !important;
    text-align: center;
    border-left: solid 1px #525252;
  }

  .userLink > div:first-child {
    border-left: none;
    position: relative;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background-color: transparent;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
    height: 106px
  }
  &.darkHeader {
    .userBar {
      //background-color: #ffffff;
      background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(4,3,34,1) 16%, rgba(4,3,48,1) 33%, rgba(6,6,65,1) 48%, rgba(3,2,79,1) 57%, rgba(3,2,71,1) 66%, rgba(14,26,58,1) 78%);
    }
    .userLink a {
      color: white;
    }
    .navLink ul, .navLink li {
      color: #CFD7D4;
    }
    .el-menu-item:hover {
      background: transparent;
    }
    #pageLink {
      background: transparent;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      color: white;
    }
    .navLink li:not(first-child) {
      margin-left: 30px;
    }
    .navLink li:first-child {
      margin-left: 20px !important;
    }
  }


}


</style>